import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {  AuctionItemSell } from 'remarketing-angular-library';
import { PurchaseHistory } from '@ally/remarketing/shared/dto';
import { ModalComponent, SpinnerComponent, TooltipComponent } from 'remarketing-ui-components-lib';
import { PurchaseHistoryComponent } from "../../../../sell/lib/manage-inventory/components/purchase-history/purchase-history.component";
import { TranslocoDirective } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import {
  OfferModalsHeaderComponent
} from '../../../ui/comment/modal-actions/offer-header/offer-modals-header.component';
import { PurchaseStatusPipe } from 'smartauction-frontend-micro-library';

@Component({
    selector: 'app-purchase-offer-history-modal',
    templateUrl: './purchase-offer-history-modal.component.html',
    styleUrls: ['./purchase-offer-history-modal.component.scss'],
    imports: [
        TranslocoDirective,
        SpinnerComponent,
        OfferModalsHeaderComponent,
        PurchaseStatusPipe,
        TooltipComponent,
        CommonModule,
        ModalComponent
    ]
})
export class PurchaseOfferHistoryModalComponent extends PurchaseHistoryComponent implements OnInit {
  @ViewChild(ModalComponent) modal: ModalComponent;
  @Input() modalId = 'purchase-offer-history-modal';
  @Input() auctionItemSell: AuctionItemSell;
  @Input() tenantName: string;
  @Input() saleDate: string;
  @Input() salePrice: number;
  @Input() vehicleTitle: string;
  public isLoading = true;

  purchaseOfferHistory: PurchaseHistory;
  historyCount = 0;
  isMobile: boolean;

  ngOnInit() {
    //overrides ngOnInit from extended class
  }

  show() {
    this.isLoading = true;
    this.getAuctionItemSellHistory(this.auctionItemSell.auctionItemUuid);
    this.isLoading = false;
    this.modal.show();
  }
}
